import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

import { ref, reactive, computed } from "vue";
import { getRandomId } from "@/mixins/global.mixin";

interface Props {
  value?: number;
  perPage?: number;
  total?: number;
  limit?: number;
  size?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VPagination',
  props: {
    value: { default: 1 },
    perPage: { default: 20 },
    total: { default: 1 },
    limit: { default: 5 },
    size: { default: "md" }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const pagination = ref();

const key = ref(getRandomId());

const classes = reactive({
  wrapper: "wrapper",
  element: "element",
  activeElement: "active-element",
  disabledElement: "disabled-element",
  ellipsisElement: "ellipsis-element",
  activeButton: "active-button",
  disabledButton: "disabled-button",
  button: "button",
  ellipsis: "ellipsis",
});

const currentPage = computed({
  get() {
    return props.value;
  },
  set(value) {
    emit("input", value);
  },
});

const totalPage = computed(() => (props.total ? props.total : 1));

const paginationWrapperClasses = computed(() => (props.size === "md" ? "size-md" : "size-sm"));

const onClickPaginationWrapper = (
  event: Event & {
    target: HTMLButtonElement;
  }
) => {
  if (event.target.innerHTML === "‹") {
    pagination.value.goToPrevPage();
  } else if (event.target.innerHTML === "›") {
    pagination.value.goToNextPage();
  } else if (+event.target.innerHTML) {
    pagination.value.selectPage(+event.target.innerHTML);
  }

  if (currentPage.value !== pagination.value.currentPage) {
    currentPage.value = pagination.value.currentPage;
    key.value = getRandomId();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_t_pagination = _resolveComponent("t-pagination")!
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pagination-wrapper", paginationWrapperClasses.value])
  }, [
    (_openBlock(), _createBlock(_component_t_pagination, {
      key: key.value,
      ref_key: "pagination",
      ref: pagination,
      "data-cy": "pagination",
      value: currentPage.value,
      classes: classes,
      "per-page": _ctx.perPage,
      "total-items": totalPage.value,
      "hide-first-last-controls": true,
      limit: _ctx.limit
    }, null, 8, ["value", "classes", "per-page", "total-items", "limit"]))
  ], 2)), [
    [_directive_touch, onClickPaginationWrapper]
  ])
}
}

})